/*

Sidebar-Abschnitt mit Bearbeiten- und Weiter-Button

*/

import { Trans } from '@lingui/macro'

function SidebarSection({id, expanded, name, selected, summary, order, editFunction, proceedFunction, children}) {

    function openSection() {
        editFunction()
    }

    function closeSection() {
        proceedFunction()
    }

    let summaryMap = Array.from(summary)    // sonst funktioniert map() nicht

    return (
        <div className={(expanded) ? 'section expanded' : 'section'} id={id}>

            {editFunction ?
                <button className="editBtn btnTertiary" onClick={openSection}><Trans>ändern</Trans></button>
            : '' }

            <h2>{name}</h2>

            <table className="summary">
                <tbody>
                    {summaryMap.map((line, i) => (
                        <tr key={i}>
                            <td>{line.text}</td>
                            <td>{line.price ? <span className="unitPrice">{line.price}</span> : null}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <div className="options_next">
                {children}
                {order!=='last' ? <button className="btnPrimary nextBtn" onClick={closeSection}><Trans>Weiter</Trans></button> : <p><br /><b><Trans>Bett fertig konfiguriert? Dann können Sie es in den Warenkorb legen:</Trans></b></p>}
            </div>

        </div>
    )

}

export default SidebarSection